export default 0;



// WEBPACK FOOTER //
// ./src/API/delay.js